export default __webpack_public_path__ + "static/media/vire4.0a613c37.jpg";